namespace RioERP.Masters {
    export interface EmailTemplateVariablesForm {
        VariableCode: Serenity.StringEditor;
        VariableName: Serenity.StringEditor;
    }

    export class EmailTemplateVariablesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.EmailTemplateVariables';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EmailTemplateVariablesForm.init)  {
                EmailTemplateVariablesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(EmailTemplateVariablesForm, [
                    'VariableCode', w0,
                    'VariableName', w0
                ]);
            }
        }
    }
}
